import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from 'src/app/services/user/user.service';
import {NavigationService} from 'src/app/services/nav/navigation.service';
import {JwtService} from 'src/app/services/user/jwt.service';
import {TenantService} from 'src/app/services/tenant.service';
import {Hub} from '@aws-amplify/core';

@Component({
    selector: 'app-handle-federated-login',
    template: '',
    styles: [],
})
export class HandleFederatedLoginComponent implements OnInit, OnDestroy {

  private hubUnsubscribe?: () => void;

  constructor(private nav: NavigationService,
              private userService: UserService,
              private jwtService: JwtService,
              private tenantService: TenantService,
              private router: Router) { }

  ngOnInit(): void {
    this.hubUnsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect') {
        this.hubUnsubscribe?.();
        this.onFederatedLoginSuccess();
      } else if (payload.event === 'signInWithRedirect_failure') {
        this.hubUnsubscribe?.();
        console.error('Federated login failed', payload);
        this.nav.login();
      }
    });
  }

  private onFederatedLoginSuccess(): void {
    if (this.tenantService.slug) {
      this.userService.refresh()
        .then(() => this.nav.home())
        .catch(() => this.nav.login());
    } else {
      this.jwtService.refresh()
        .then(() => this.router.navigate(['/explore']))
        .catch(() => this.nav.login());
    }
  }

  ngOnDestroy(): void {
    this.hubUnsubscribe?.();
  }

}
